import Icon from '../../components/Icon';
import CampoTexto from '../../components/Formulario/CampoTexto';
import AlertBox from '../../components/layout/AlertBox';
import LayoutUsuario from '../../components/navegacao/LayoutUsuario';
import TituloChat from './TituloChat';
import styles from './page.module.css';
import {
  mdiAlertCircleOutline,
  mdiCheckCircle,
  mdiCross,
  mdiFilter,
  mdiFilterCheck,
  mdiHeadset,
  mdiInformationOutline,
  mdiMagnify,
  mdiMessageProcessing,
  mdiMicrophoneOff,
  mdiOpenInNew,
  mdiPhone,
  mdiRobot,
  mdiTrashCan,
} from '@mdi/js';
import CampoSeletor from '../../components/Formulario/CampoSeletor';
import Tabs from '../../components/layout/Tabs';
import Conversas from './Conversas';
import Mensagens from './Mensagens';
import { chatKey } from './chatList';
import { configurarRascunhos } from './rascunhos';
import ChatDto from '@tera/shared/src/dto/ChatDto';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import useWebsocket from './useWebsocket';
import {
  ChatMessagePayload,
  ChatMessagePayloadFile,
} from '@tera/shared/src/types/ChatMessagePayload';
import { useDebounce } from '../../hooks/useDebounce';
import axios from 'axios';
import { useMutation, useQuery } from 'react-query';
import IconeCanal from '../../components/layout/IconeCanal';
import HBox from '../../components/layout/HBox';
import Modal from '../../components/layout/Modal';
import { useAuth } from '../../lib/useAuth';
import Subtitulo from '@/components/tipografia/Subtitulo';
import Titulo from '@/components/tipografia/Titulo';
import VBox from '@/components/layout/VBox';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Botao from '@/components/Botao';
import { Tutorial } from '@/components/Tutorial';
import { TutoriaisKeys } from '@tera/shared/src/tutoriais/constants';
import { FormMensagemProgramada } from '../mensagem_programada/FormMensagemProgramada';
import CampoMemo from '@/components/Formulario/CampoMemo';
import { toast } from 'react-toastify';
import { queryClient } from '@/queryClient';
import { subscribeUserToPush } from '@/lib/webpush';
import CampoModeloMensagem from '../../components/Formulario/CampoModeloMensagem';
import Ligacao from './Ligacao';
import { useLigacaoLiveKit } from '../../hooks/useLigacaoLiveKit';
import Grid, { GridItem } from '@/components/layout/Grid';
import CampoData from '@/components/Formulario/CampoData';
import BotaoDropdown from '@/components/BotaoDropdown';
import { set } from 'date-fns';
import { CampoSeletorCliente } from '@/components/modelos/CampoSeletorCliente';
import { FormCliente } from '../cliente/FormCliente';
import CampoRadio from '@/components/Formulario/CampoRadio';
import { CanalTipo } from '@tera/shared/src/dto/CanalDto';
import useAudioDevices from '@/hooks/useAudioDevices';
import AudioDevicesIndicator from '@/components/AudioDevicesIndicator';
import PopupDiscagem from '@/components/modelos/PopupDiscagem';

export const stateEnum = {
  INIT: 'init',
  LOADING_PREFS: 'loading_prefs',
  PREFS_LOADED: 'prefs_loaded',
  WAIT_DEBOUNCE: 'wait_debounce',
  ERROR: 'error',
  READY: 'ready',
} as const;
export type StateEnumType = typeof stateEnum[keyof typeof stateEnum];

type ModalAbrirChatMensagemProgramadaProps = {
  canalId: number | null;
  open: boolean;
  onClose: () => void;
  onConfirm: (mensagemId: string, params: Record<string, string>) => void;
};

type LigacaoState = {
  status: 'iniciando' | 'em_andamento' | 'finalizando';
  startDate: Date | null;
  isMuted: boolean;
  isSpeakerOn: boolean;
  isMinimized: boolean;
}

const SubTexto = ({ children }: { children: React.ReactNode }) => (
  <p style={{ fontSize: '0.8rem', color: 'var(--tc-color-gray-500)', fontStyle: 'italic', marginBottom: '0.5rem' }}>{children}</p>
);

type ObjNewChat = {
  canalTipo?: CanalTipo | null;
  canalValor?: string | null;
  clienteId?: number | null;
  mensagemProgramadaId?: number | null;
  paramsMensagem?: Record<string, string> | null;
}

type ModalNewChatProps = {
  value: ObjNewChat | null;
  onChange: (value: ObjNewChat | null) => void;
  onConfirm: () => void;
}

const ModalNewChat = ({
  value,
  onChange,
  onConfirm,
}: ModalNewChatProps) => {

  const [objNovoCliente, setObjNovoCliente] = useState<any>(null);
  const [feNovoCliente, setFeNovoCliente] = useState({});

  const clienteQuery = useQuery(
    ['cliente', value?.clienteId],
    () => {
      return fetch(
        '/api/cliente/' + value?.clienteId,
      ).then(res => res.json());
    },
    {
      enabled: value?.clienteId != null,
      staleTime: 30000,
      onSuccess: (data) => {
        if (data?.result) {
          const contato = data.result.contatos?.filter((c: any) => !['telefone', 'voip'].includes(c.tipo)) ?? []

          onChange({
            ...value!,
            canalTipo: contato?.[0]?.tipo || null,
            canalValor: contato?.[0]?.valor || null,
          });
        }
      }
    },
  );

  const addClienteMutator = useMutation(
    async () => {
      if (!objNovoCliente) return;

      setFeNovoCliente({});
      if (objNovoCliente.id) {
        return await axios.put(`/api/cliente/${objNovoCliente.id}`, objNovoCliente, {
          withCredentials: true,
        });
      } else {
        return await axios.post(`/api/cliente`, objNovoCliente, {
          withCredentials: true,
        });
      }
    },
    {
      onSuccess: (response) => {
        setFeNovoCliente({});
        setObjNovoCliente(null);

        queryClient.invalidateQueries('cliente');
        queryClient.invalidateQueries('cliente/box');

        if (response?.data?.result?.id) {
          onChange({
            ...value!,
            clienteId: response.data.result.id,
          });
        }

        toast(!objNovoCliente.id ? 'Contato adicionado com sucesso' : 'Contato alterado com sucesso', {
          toastId: !objNovoCliente.id ? 'add-success' : 'edit-success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
      },
      onError: (err: any) => {
        if (err.response?.status === 422) {
          setFeNovoCliente(err.response?.data?.fieldErrors ?? {});
        }
        toast(err.response?.data?.msg ?? 'Erro desconhecido', {
          toastId: !objNovoCliente.id ? 'add-error' : 'edit-error',
          position: 'top-center',
          type: 'warning',
          autoClose: 5000,
        });
      },
    },
  );

  const selectedClient = clienteQuery.data?.result;

  const msgProgramadaQuery = useQuery(
    ['mensagem_programada/cli', value?.canalTipo],
    async () => {
      const res = await axios.get('/api/mensagem_programada?fi=' +
        encodeURIComponent(JSON.stringify({ estado: ['eq', 'aprovada'] })));

      return res.data?.result?.filter((msg: any) => msg?.canal?.tipo === value?.canalTipo);
    },
    {
      enabled: value?.canalTipo != null,
      staleTime: 30000,
    },
  );

  const msgProgramadaOptions = msgProgramadaQuery.data?.map((msg: any) => ({
    id: msg.id,
    label: `${msg.nome} (${msg.canal?.nome || 'Sem canal'})`,
  })) ?? [];


  const msgProgramada = msgProgramadaQuery.data?.find(
    (msg: any) => msg.id === value?.mensagemProgramadaId,
  );

  return (
    <>
      <Modal
        size="md"
        title="Nova conversa"
        show={value !== null}
        onClose={() => onChange(null)}
        onCancel={() => onChange(null)}
        onConfirm={() => {
          onConfirm?.();
          setObjNovoCliente(null);
          setFeNovoCliente({});
        }}
        confirmProps={{
          disabled: value?.canalTipo == null
            || value?.clienteId == null
            || value?.mensagemProgramadaId == null
            || (value?.paramsMensagem != null && Object.values(value?.paramsMensagem).some(v => v === '')),
        }}
      >
        <SubTexto>Envie uma notificação para novos contatos e aguarde a resposta deles para iniciar uma conversa.</SubTexto>
        <SubTexto><b>NOTA:</b> Podem ocorrer cobranças de notificações.</SubTexto>
        <Grid>
          <GridItem sm={12}>
            <VBox>
              <CampoSeletorCliente
                label="Cliente"
                value={value?.clienteId}
                onChange={(v: string | null) => onChange({ ...value, clienteId: v ? +v : null })}
                onNovoCliente={() => { setObjNovoCliente({}); setFeNovoCliente({}); }}
              />
              {!selectedClient && (
                <SubTexto>(Selecione um cliente)</SubTexto>
              )}

              {selectedClient != null && (<>
                <label>Canal de Atendimento</label>
                {selectedClient?.contatos?.filter((c: any) => !['telefone', 'voip'].includes(c.tipo))?.map((contato: any) => (
                  <CampoRadio
                    key={contato.id}
                    id={`canal-${contato.id}`}
                    label={<HBox><IconeCanal tipo={contato.tipo} style={{ height: '24px' }} /> {contato.tipo} - {contato.valor}</HBox>}
                    checked={value?.canalTipo === contato.tipo && value?.canalValor === contato.valor}
                    onChange={() => onChange({ ...value, canalTipo: contato.tipo, canalValor: contato.valor })}
                  />
                ))}

                {selectedClient && !Boolean(selectedClient.contatos?.length) && (
                  <AlertBox variant="warning" style={{ marginTop: '0.5rem' }}>
                    <Icon path={mdiAlertCircleOutline} size={1} />
                    <p>Este cliente não possui contatos disponíveis para iniciar uma conversa.</p>
                    <p>Por favor, <Link to={`/cliente?ids=${selectedClient.id}`} style={{ textDecoration: 'none', color: 'var(--tc-color-primary)' }}>adicione um contato</Link> ao cliente.</p>
                  </AlertBox>
                )}
              </>
              )}
            </VBox>
          </GridItem>
          <GridItem sm={12}>
            <CampoSeletor
              disabled={value?.canalTipo == null}
              label="Modelo de Mensagem"
              options={msgProgramadaOptions}
              value={value?.mensagemProgramadaId?.toString() ?? undefined}
              onChange={(v: string | null) => onChange({ ...value, mensagemProgramadaId: v ? +v : null })}
            />
          </GridItem>
          <GridItem sm={12}>
            <div style={{ border: '2px solid var(--tc-color-gray-300)', borderRadius: 4, padding: '8px' }}>
              {!msgProgramada?.conteudo && (
                <SubTexto>(Nenhum modelo selecionado)</SubTexto>
              )}

              {msgProgramada?.conteudo && (
                <CampoModeloMensagem
                  disabled={value?.mensagemProgramadaId == null}
                  texto={msgProgramada?.conteudo}
                  initialParams={value?.paramsMensagem || {}}
                  onParamsChange={(v) => onChange({ ...value, paramsMensagem: v })}
                />
              )}
            </div>
          </GridItem>
        </Grid>
      </Modal>

      <Modal
        title="Novo cliente"
        show={objNovoCliente !== null}
        onClose={() => setObjNovoCliente(null)}
        onCancel={() => setObjNovoCliente(null)}
        onConfirm={() => addClienteMutator.mutateAsync()}
        confirmProps={{ disabled: addClienteMutator.isLoading }}
      >
        <Grid>
          <GridItem sm={12}>
            <FormCliente
              value={objNovoCliente}
              onChange={setObjNovoCliente}
              fieldErrors={feNovoCliente}
            />
          </GridItem>
        </Grid>
      </Modal>
    </>
  );
}

const ModalAbrirChatMensagemProgramada = ({
  canalId,
  open,
  onClose,
  onConfirm,
}: ModalAbrirChatMensagemProgramadaProps) => {
  const [idMensagem, setIdMensagem] = useState<string | null>(null);
  const [paramsMensagem, setParamsMensagem] = useState<Record<string, string>>({});
  const [mensagemFieldErrors, setMensagemFieldErrors] = useState<Record<string, string> | null>(null);
  const [novaMsgProgramada, setNovaMsgProgramada] = useState<string>('');
  const [nmpFieldErrors, setNmpFieldErrors] = useState<Record<string, string>>({});
  const [msgCriada, setMsgCriada] = useState<boolean>(false);

  const mensagensQuery = useQuery(
    ['mensagem_programada', canalId],
    () => {
      return fetch(
        '/api/mensagem_programada?fi=' +
        encodeURIComponent(JSON.stringify({ canal_id: ['eq', canalId], estado: ['eq', 'aprovada'] })),
      ).then(res => res.json());
    },
    {
      staleTime: 30000,
      onSuccess: () => {
        console.log('mensagensQuery returned');
      },
    },
  );

  const mensagensTexto =
    mensagensQuery.data?.result?.filter((msg: any) => msg.formato_interacao === 'texto' && (!msg.botoes || msg.botoes.length === 0))?.map((msg: any) => ({
      id: msg.id,
      label: msg.nome,
    })) ?? [];


  const mensagensLigacao =
    mensagensQuery.data?.result?.filter((msg: any) => msg.formato_interacao === 'ligacao')?.map((msg: any) => ({
      id: msg.id,
      label: msg.nome,
    })) ?? [];

  const mensagem = mensagensQuery.data?.result?.find(
    (msg: any) => msg.id === idMensagem,
  );

  const renderHeaderPreview = React.useCallback((mp: any) => {
    if (!mp) return null;
    if (!mp.cabecalho_tipo || mp.cabecalho_tipo === 'nenhum') return null;
    if (mp.cabecalho_tipo === 'texto') {
      return (
        <div style={{ marginBottom: '8px', color: '#103668' }}>
          <b>{mp.cabecalho_texto}</b>
        </div>
      );
    }
    if (!mp.cabecalho_texto) return null;
    const filename = mp.cabecalho_texto;
    const parts = ["/api/assets", "mensagem_programada", mp.id, encodeURIComponent(filename)].join('/')

    if (mp.cabecalho_tipo === 'imagem') {
      return (
        <div style={{ marginBottom: '8px' }}>
          <img src={parts} alt="cabeçalho" style={{ maxWidth: '100%', maxHeight: '120px', borderRadius: 8 }} />
        </div>
      );
    }
    if (mp.cabecalho_tipo === 'video') {
      return (
        <div style={{ marginBottom: '8px' }}>
          <video controls style={{ maxWidth: '100%', maxHeight: '120px', borderRadius: 8 }}>
            <source src={parts} type="video/mp4" />
          </video>
        </div>
      );
    }
    if (mp.cabecalho_tipo === 'documento') {
      return (
        <div style={{ marginBottom: '8px' }}>
          <a href={parts} target="_blank" rel="noreferrer">{filename}</a>
        </div>
      );
    }
    return null;
  }, []);

  const createNovaMsgProgramada = useMutation({
    mutationFn: async (data: any) => {
      return axios.post('/api/mensagem_programada', data);
    },
    onSuccess: ({ data }) => {
      toast('Modelo adicionado com sucesso', {
        toastId: 'add-success',
        position: 'top-center',
        type: 'success',
        autoClose: 5000,
      });

      setNovaMsgProgramada('');
      queryClient.invalidateQueries(['mensagem_programada']);
      setMsgCriada(data.result.estado !== 'aprovada');
      if (data.result.estado === 'aprovada') {
        setIdMensagem(data.result.id);
      }
    },
    onError: (err: any) => {
      if (err.response?.status === 422) {
        setNmpFieldErrors(err.response?.data?.fieldErrors ?? {});
      }
      toast(err.response?.data?.msg ?? 'Erro desconhecido', {
        toastId: 'add-error',
        position: 'top-center',
        type: 'warning',
        autoClose: 5000,
      });
    },
  })

  const handleCreateNovaMsgProgramada = async () => {
    createNovaMsgProgramada.mutateAsync({
      nome: 'Retomar atendimento',
      conteudo: novaMsgProgramada,
      canal_id: canalId,
      categoria: 'notificacao',
    });
  }

  const handleClose = async () => {
    onClose();
    setIdMensagem(null);
    setNovaMsgProgramada('');
    setNmpFieldErrors({});
    setMsgCriada(false);
  }

  const handleConfirm = async () => {
    // validar se há parâmetros necessários
    if (mensagem.conteudo.indexOf('{{') !== -1) {
      const parametros = mensagem.conteudo.match(/{{([^{}]+)}}/g);
      if (parametros) {
        const missingParams = parametros
          .map((p: string) => p.replace(/{{|}}/g, '').trim())
          .filter((p: string) => !paramsMensagem[p]);
        if (missingParams.length > 0) {
          setMensagemFieldErrors({ conteudo: `Faltam parâmetros: ${missingParams.join(', ')}` });
          return;
        }
      }
    }

    onConfirm(idMensagem!, paramsMensagem);
    setMensagemFieldErrors(null);
    setIdMensagem(null);
    setParamsMensagem({});
    setNovaMsgProgramada('');
    setNmpFieldErrors({});
    setMsgCriada(false);
  }

  return (
    <Modal
      title="Abrir chat"
      show={open}
      onClose={handleClose}
      onConfirm={handleConfirm}
      confirmProps={{
        label: 'Enviar',
        disabled: !idMensagem,
      }}
      cancelProps={{
        label: 'Cancelar',
      }}
    >
      {mensagensQuery.isFetching && <VBox center><p>Carregando...</p></VBox>}
      {!mensagensQuery.isFetching && !msgCriada && mensagensTexto?.length === 0 && (
        <VBox center>
          <Subtitulo style={{ color: 'var(--tc-color-primary)' }}>Seu primeiro modelo de mensagem, pronto para uso!</Subtitulo>
          <p>Escreva uma mensagem clara e objetiva para iniciar a conversa com o cliente. Lembre de explicar o por que está entrando em contato com ele.</p>
          <CampoMemo
            instanceId='conteudo'
            placeholder='Escreva aqui a mensagem que deseja enviar ao cliente'
            value={novaMsgProgramada}
            onChange={setNovaMsgProgramada}
            error={nmpFieldErrors['conteudo']}
            min={25}
            max={250}
          />
          <p style={{ fontStyle: 'italic' }}>(Um exemplo: "Olá! Nosso time comercial está disponível neste momento para conversar com você. Podemos continuar?")</p>
          <Botao variant="primary" onClick={handleCreateNovaMsgProgramada} disabled={createNovaMsgProgramada.isLoading}>
            Confirmar
          </Botao>
        </VBox>
      )}

      {!mensagensQuery.isFetching && !msgCriada && mensagensTexto?.length > 0 && (
        <>
          <CampoSeletor
            label="Selecione a mensagem programada a enviar para o cliente"
            options={mensagensTexto}
            value={idMensagem ?? undefined}
            onChange={setIdMensagem}
            optionLabel="nome"
            optionValue="id"
          />
          <div
            style={{
              marginTop: '1rem',
              fontSize: '1.2rem',
              fontWeight: 'lighter',
              textAlign: 'center',
            }}
          >
            {renderHeaderPreview(mensagem)}
            <CampoModeloMensagem
              texto={mensagem?.conteudo ?? '(nenhuma mensagem selecionada)'}
              initialParams={paramsMensagem}
              onParamsChange={setParamsMensagem}
            />
            {mensagemFieldErrors?.conteudo && (
              <div style={{ width: '100%', marginTop: '0.5rem', color: 'var(--tc-color-danger)', fontSize: '0.8rem' }}>
                {mensagemFieldErrors.conteudo}
              </div>
            )}
          </div>

          <AlertBox variant="info" style={{ marginTop: '1rem' }}>
            <Icon path={mdiInformationOutline} size={1} />
            <b>Nota:</b> Outras conversas em aberto com o cliente serão encerradas
          </AlertBox>
        </>
      )}

      {!mensagensQuery.isFetching && msgCriada && (
        <VBox center>
          <Subtitulo style={{ color: 'var(--tc-color-primary)' }}>Em análise</Subtitulo>
          <img src="/look-msg-model-min.png" style={{ width: '300px' }} />
          <p>O novo modelo de mensagem está em análise. Assim que for aprovado, estará disponível para uso.</p>
        </VBox>
      )}

    </Modal>
  );
};


const ModalSolicitarLigacaoMensagemProgramada = ({
  canalId,
  open,
  onClose,
  onConfirm,
}: ModalAbrirChatMensagemProgramadaProps) => {
  const [idMensagem, setIdMensagem] = useState<string | null>(null);
  const [paramsMensagem, setParamsMensagem] = useState<Record<string, string>>({});
  const [mensagemFieldErrors, setMensagemFieldErrors] = useState<Record<string, string> | null>(null);
  const [novaMsgProgramada, setNovaMsgProgramada] = useState<string>('');
  const [nmpFieldErrors, setNmpFieldErrors] = useState<Record<string, string>>({});
  const [msgCriada, setMsgCriada] = useState<boolean>(false);

  const mensagensQuery = useQuery(
    ['mensagem_programada', canalId],
    () => {
      return fetch(
        '/api/mensagem_programada?fi=' +
        encodeURIComponent(JSON.stringify({ canal_id: ['eq', canalId], estado: ['eq', 'aprovada'] })),
      ).then(res => res.json());
    },
    {
      staleTime: 30000,
      onSuccess: () => {
        console.log('mensagensQuery returned');
      },
    },
  );

  const mensagensLigacao =
    mensagensQuery.data?.result?.filter((msg: any) => msg.formato_interacao === 'ligacao')?.map((msg: any) => ({
      id: msg.id,
      label: msg.nome,
    })) ?? [];

  const mensagem = mensagensQuery.data?.result?.find(
    (msg: any) => msg.id === idMensagem,
  );

  const renderHeaderPreview = React.useCallback((mp: any) => {
    if (!mp) return null;
    if (!mp.cabecalho_tipo || mp.cabecalho_tipo === 'nenhum') return null;
    if (mp.cabecalho_tipo === 'texto') {
      return (
        <div style={{ marginBottom: '8px', color: '#103668' }}>
          <b>{mp.cabecalho_texto}</b>
        </div>
      );
    }
    if (!mp.cabecalho_texto) return null;
    const filename = mp.cabecalho_texto;
    const parts = ["/api/assets", "mensagem_programada", mp.id, encodeURIComponent(filename)].join('/')

    if (mp.cabecalho_tipo === 'imagem') {
      return (
        <div style={{ marginBottom: '8px' }}>
          <img src={parts} alt="cabeçalho" style={{ maxWidth: '100%', borderRadius: 8 }} />
        </div>
      );
    }
    if (mp.cabecalho_tipo === 'video') {
      return (
        <div style={{ marginBottom: '8px' }}>
          <video controls style={{ maxWidth: '100%', borderRadius: 8 }}>
            <source src={parts} type="video/mp4" />
          </video>
        </div>
      );
    }
    if (mp.cabecalho_tipo === 'documento') {
      return (
        <div style={{ marginBottom: '8px' }}>
          <a href={parts} target="_blank" rel="noreferrer">{filename}</a>
        </div>
      );
    }
    return null;
  }, []);

  const createNovaMsgProgramada = useMutation({
    mutationFn: async (data: any) => {
      return axios.post('/api/mensagem_programada', data);
    },
    onSuccess: ({ data }) => {
      toast('Modelo adicionado com sucesso', {
        toastId: 'add-success',
        position: 'top-center',
        type: 'success',
        autoClose: 5000,
      });

      setNovaMsgProgramada('');
      queryClient.invalidateQueries(['mensagem_programada']);
      setMsgCriada(data.result.estado !== 'aprovada');
      if (data.result.estado === 'aprovada') {
        setIdMensagem(data.result.id);
      }
    },
    onError: (err: any) => {
      if (err.response?.status === 422) {
        setNmpFieldErrors(err.response?.data?.fieldErrors ?? {});
      }
      toast(err.response?.data?.msg ?? 'Erro desconhecido', {
        toastId: 'add-error',
        position: 'top-center',
        type: 'warning',
        autoClose: 5000,
      });
    },
  })

  const handleCreateNovaMsgProgramada = async () => {
    createNovaMsgProgramada.mutateAsync({
      nome: 'Retomar atendimento',
      conteudo: novaMsgProgramada,
      canal_id: canalId,
      categoria: 'marketing',
      formato_interacao: 'ligacao'
    });
  }

  const handleClose = async () => {
    onClose();
    setIdMensagem(null);
    setNovaMsgProgramada('');
    setNmpFieldErrors({});
    setMsgCriada(false);
  }

  const handleConfirm = async () => {
    // validar se há parâmetros necessários
    if (mensagem.conteudo.indexOf('{{') !== -1) {
      const parametros = mensagem.conteudo.match(/{{([^{}]+)}}/g);
      if (parametros) {
        const missingParams = parametros
          .map((p: string) => p.replace(/{{|}}/g, '').trim())
          .filter((p: string) => !paramsMensagem[p]);
        if (missingParams.length > 0) {
          setMensagemFieldErrors({ conteudo: `Faltam parâmetros: ${missingParams.join(', ')}` });
          return;
        }
      }
    }

    onConfirm(idMensagem!, paramsMensagem);
    setMensagemFieldErrors(null);
    setIdMensagem(null);
    setParamsMensagem({});
    setNovaMsgProgramada('');
    setNmpFieldErrors({});
    setMsgCriada(false);
  }

  return (
    <Modal
      title="Abrir chat"
      show={open}
      onClose={handleClose}
      onConfirm={handleConfirm}
      confirmProps={{
        label: 'Enviar',
        disabled: !idMensagem,
      }}
      cancelProps={{
        label: 'Cancelar',
      }}
    >
      {mensagensQuery.isFetching && <VBox center><p>Carregando...</p></VBox>}
      {!mensagensQuery.isFetching && !msgCriada && mensagensLigacao?.length === 0 && (
        <VBox center>
          <Subtitulo style={{ color: 'var(--tc-color-primary)' }}>Seu primeiro modelo de mensagem, pronto para uso!</Subtitulo>
          <p>Escreva uma mensagem clara e objetiva para iniciar a ligação com o cliente. Lembre de explicar o por que está entrando em contato com ele.</p>
          <CampoMemo
            instanceId='conteudo'
            placeholder='Escreva aqui a mensagem que deseja enviar ao cliente'
            value={novaMsgProgramada}
            onChange={setNovaMsgProgramada}
            error={nmpFieldErrors['conteudo']}
            min={25}
            max={250}
          />
          <p style={{ fontStyle: 'italic' }}>(Um exemplo: "Olá! Nosso time comercial está disponível neste momento para conversar com você. Podemos ligar para você?")</p>
          <Botao variant="primary" onClick={handleCreateNovaMsgProgramada} disabled={createNovaMsgProgramada.isLoading}>
            Confirmar
          </Botao>
        </VBox>
      )}

      {!mensagensQuery.isFetching && !msgCriada && mensagensLigacao?.length > 0 && (
        <>
          <CampoSeletor
            label="Selecione a mensagem programada a enviar para o cliente"
            options={mensagensLigacao}
            value={idMensagem ?? undefined}
            onChange={setIdMensagem}
            optionLabel="nome"
            optionValue="id"
          />
          <div
            style={{
              marginTop: '1rem',
              fontSize: '1.2rem',
              fontWeight: 'lighter',
              textAlign: 'center',
            }}
          >
            {renderHeaderPreview(mensagem)}
            <CampoModeloMensagem
              texto={mensagem?.conteudo ?? '(nenhuma mensagem selecionada)'}
              initialParams={paramsMensagem}
              onParamsChange={setParamsMensagem}
            />
            {mensagemFieldErrors?.conteudo && (
              <div style={{ width: '100%', marginTop: '0.5rem', color: 'var(--tc-color-danger)', fontSize: '0.8rem' }}>
                {mensagemFieldErrors.conteudo}
              </div>
            )}
          </div>
        </>
      )}

      {!mensagensQuery.isFetching && msgCriada && (
        <VBox center>
          <Subtitulo style={{ color: 'var(--tc-color-primary)' }}>Em análise</Subtitulo>
          <img src="/look-msg-model-min.png" style={{ width: '300px' }} />
          <p>O novo modelo de mensagem está em análise. Assim que for aprovado, estará disponível para uso.</p>
        </VBox>
      )}

    </Modal>
  );
};

const pubKey = import.meta.env.VITE_PUB_KEY;

const Page = () => {
  const [urlSearch] = useSearchParams();

  const [chatEstadoIsLoading, setChatEstadoIsLoading] =
    React.useState<boolean>(false);

  const [confirmCloseChat, setConfirmCloseChat] =
    React.useState<boolean>(false);
  const [confirmOpenChat, setConfirmOpenChat] = React.useState<boolean>(false);
  const [confirmMakeCall, setConfirmMakeCall] = React.useState<boolean>(false);
  const [notificationStatus, setNotificationStatus] =
    React.useState<NotificationPermission>('default');

  const uid = urlSearch.get('uid');
  const ccid = urlSearch.get('ccid');
  const canalIdParam = urlSearch.get('canal_id');

  const originalQuery = useMemo(() => {
    return {
      search: '',
      chatStatus: '',
      canalId: undefined,
      userId: uid != null ? +uid : undefined,
      dataInicio: undefined,
      dataFim: undefined,
      chatTags: [],
      mode: 'recent' as 'related' | 'recent',
      apenasMeus: undefined as boolean | undefined,
      usuarioResponsavelId: [] as string[],
      grupoResponsavelId: [] as string[],
    }
  }, [uid]);

  const [query, setQuery] = React.useState<{
    search?: string;
    chatStatus?: string;
    canalId?: number;
    userId?: number;
    dataInicio?: string;
    dataFim?: string;
    chatTags?: string[];
    mode?: 'related' | 'recent';
    apenasMeus?: boolean;
    usuarioResponsavelId?: string[];
    grupoResponsavelId?: string[];
  }>(() => ({ ...originalQuery, search: ccid ?? '', canalId: canalIdParam != null ? +canalIdParam : undefined }));

  const [messageWhileFiltered, setMessageWhileFiltered] = useState<boolean>(false);

  const { user } = useAuth();

  // Rascunhos são por atendente: navegador compartilhado não pode misturar.
  useEffect(() => {
    configurarRascunhos(user?.id);
  }, [user?.id]);

  // Query para buscar se há canais VoIP cadastrados (para mostrar avisos de microfone)
  const hasVoipCanaisQuery = useQuery(
    ['has-voip-canais'],
    async () => {
      const { data } = await axios.get('/api/canal?fi=' + encodeURIComponent(JSON.stringify({ tipo: ['eq', 'voip'] })));
      return (data?.result?.length || 0) > 0;
    },
    {
      staleTime: 300000, // Cache por 5 minutos
    }
  );

  // Atualizado pelo monitor de frames abaixo; declarado aqui para o useWebsocket.
  const isPageActive = useRef(true);

  const {
    socket: websocket,
    wsState,
    chatState,
    chatAddTag,
    reloadChats,
    selectChat,
    loadMoreChats,
    sendMessage,
    atenderFila,
    atenderChamada,
    sendNotification,
    sendAudio,
    loadMore,
    sendTypingStatus,
    sendAudioDevicesStatus,
  } = useWebsocket({
    userId: user?.id,
    isPageActive,
    userRole: user?.papel,
    query,
    onLoadingChats: (status: boolean) => {
      console.log('reload chats', status);
    },
    onChatsUpdated: (chats: ChatDto[]) => {
      console.log('chats updated', chats);
    },
    onConnected: () => {
      console.log('reconnected');
      console.warn('reload by reconnection');
      websocket.emit('hello', { mobile: false, active: true });

      setTimeout(() => reloadChats(query), 500);
    },
    onAcceptedCall: (id: number, userId: number) => {
      conectarLigacao(id);
    },
    onNewMessageWhileFiltered: () => {
      setMessageWhileFiltered(true);
    },
    hasVoipCanais: hasVoipCanaisQuery.data || false,
  });

  // Hook para detecção de dispositivos de áudio
  const {
    hasMicrophone,
    hasSpeakers,
    hasPermission,
    canHandleCalls: localCanHandleCalls,
    getWarningMessage
  } = useAudioDevices();

  // Enviar status de dispositivos de áudio quando conectar ou quando mudar
  useEffect(() => {
    if (wsState === 'connected' && sendAudioDevicesStatus) {
      sendAudioDevicesStatus({
        hasMicrophone,
        hasSpeakers,
        hasPermission,
      });
    }
  }, [wsState, hasMicrophone, hasSpeakers, hasPermission, sendAudioDevicesStatus]);

  const deltaThreshold = 50
  const countThreshold = 5

  const pageActivityCounter = useRef(0);
  const lastFrameTime = useRef(Date.now());

  const activityIntervalRef = useRef<any>(null);


  const monitorFrameActivity = () => {
    lastFrameTime.current = Date.now();
    requestAnimationFrame(monitorFrameActivity);
  }

  useEffect(() => {
    // Inicia o monitoramento
    requestAnimationFrame(monitorFrameActivity);

    activityIntervalRef.current = setInterval(() => {
      const currentFrameTime = Date.now();

      const delta = currentFrameTime - lastFrameTime.current;

      // Detectar retorno à atividade
      if (delta <= deltaThreshold) {
        pageActivityCounter.current = Math.min(countThreshold, pageActivityCounter.current + 1);
      } else {
        pageActivityCounter.current = Math.max(-countThreshold, pageActivityCounter.current - 1);
      }

      if (pageActivityCounter.current > (countThreshold * 0.75) && !isPageActive.current) {
        isPageActive.current = true;
        websocket.emit('active', true);
        console.log('active');
      } else if (pageActivityCounter.current < -(countThreshold * 0.75) && isPageActive.current) {
        isPageActive.current = false;
        websocket.emit('active', false);
        console.log('inactive');
      }
    }, 50)

    // Cleanup ao desmontar
    return () => {
      clearInterval(activityIntervalRef.current);
    };
  }, []);

  // Conversa aberta: resolvida pela identidade guardada na seleção, nunca pela
  // posição na lista (que é reordenada a cada evento de socket). O canal só
  // entra na comparação quando é conhecido — chats inseridos por eventos de
  // fila podem chegar sem ele.
  // O botão "atualizar" recarrega só a primeira página: se a conversa aberta
  // estava numa página seguinte, ela sai da lista e sobra apenas a cópia
  // guardada pelo reducer (`selectedChatSnapshot`). A lista tem precedência —
  // qualquer evento que reinsira o chat volta a alimentar o painel com os
  // dados vivos.
  const selectedChat = chatState.selectedChatClientId
    ? chatState.chats?.find(
      (chat: any) =>
        chat.canal_cliente_id?.toString() === chatState.selectedChatClientId &&
        (chatState.selectedChatCanalId == null ||
          (chat.canal_id ?? chat.canal?.id) == chatState.selectedChatCanalId),
    ) ?? chatState.selectedChatSnapshot ?? undefined
    : undefined;
  const selectedChatKey = chatKey(selectedChat);

  const chatCanBeOpened = selectedChat
    ? selectedChat.estado !== 'atendimento' &&
    new Date().getTime() -
    new Date(selectedChat.ultmsg_data_criacao).getTime() <
    23 * 50 * 60 * 1000
    : false;

  const loadMoreMessages = useCallback(
    (dt: string) => {
      console.log('is fetching? ', chatState.loadingMessages);
      if (chatState.loadingMessages) return;

      console.log('fetching more');

      loadMore(dt);
    },
    [chatState.loadingMessages, loadMore],
  );

  const handleSelectChat = useCallback(
    (chat: ChatDto | null) => {
      console.log('selected chat', chat);
      selectChat(chat as ChatDto);
    },
    [selectChat],
  );

  const handleChatEstadoChange = useCallback(
    (estado: string, solucionado?: boolean) => {
      if (!selectedChat) return;

      setChatEstadoIsLoading(() => true);
      try {
        websocket.emit('chat.state', {
          chat_id: selectedChat.id,
          state: estado,
          solucionado,
        });
      } finally {
        setChatEstadoIsLoading(() => false);
      }
    },
    [selectedChat, websocket],
  );

  const onChatEstadoChange = useCallback(
    async (estado: string, solucionado?: boolean): Promise<void> => {
      // if (estado === 'finalizado') {
      //   setConfirmCloseChat(true);
      //   return;
      // }

      if (estado === 'atendimento' && !chatCanBeOpened) {
        setConfirmOpenChat(true);
        return;
      }

      handleChatEstadoChange(estado, solucionado);
    },
    [handleChatEstadoChange, chatCanBeOpened],
  );

  const handleSend = useCallback(
    async (message: string, attachments: File[]) => {
      const destino = selectedChat as any;
      if (!destino) {
        console.warn('[handleSend] envio ignorado: nenhuma conversa aberta');
        return;
      }

      const _attachments = await Promise.all(
        attachments.map(
          async f =>
            ({
              name: f.name,
              size: f.size,
              type: f.type,
              buffer: await f.arrayBuffer(),
            }) as unknown as ChatMessagePayloadFile,
        ),
      );

      const msg: ChatMessagePayload = {
        canal_cliente_id: destino.canal_cliente_id,
        canal_id: destino.canal_id ?? destino.canal?.id,
        // Vem da seleção explícita da atendente, não do item resolvido na
        // lista: se as duas fontes divergirem, o servidor recusa o envio em vez
        // de entregar a mensagem a outro destinatário.
        chat_id: chatState.selectedChatId ?? destino.id ?? null,
        message,
        attachments: _attachments,
        __trace: 5,
      };

      sendMessage(msg);
    },
    [selectedChat, chatState.selectedChatId, sendMessage],
  );

  const handleSendAudio = useCallback(
    async (audio: Blob) => {
      const destino = selectedChat as any;
      if (!destino) {
        console.warn('[handleSendAudio] envio ignorado: nenhuma conversa aberta');
        return;
      }

      sendAudio(
        destino.canal_cliente_id,
        destino.canal_id ?? destino.canal?.id,
        audio,
        chatState.selectedChatId ?? destino.id ?? null,
      );
    },
    [selectedChat, chatState.selectedChatId, sendAudio],
  );

  async function askPermission() {
    Notification.requestPermission().then(function (result) {
      setNotificationStatus(result);
      if (result !== 'granted') {
        console.warn("We weren't granted permission.");
      } else {
        subscribeUserToPush(pubKey);
      }
    });
  }

  useEffect(() => {
    // Removido: lógica de carregamento de preferências do usuário
    websocket.connect();
    return () => {
      websocket.disconnect();
    };
  }, [websocket]);

  useEffect(() => {
    // Removido: lógica de transição de estado relacionada a prefs
  }, [query]);

  useEffect(() => {
    setNotificationStatus(
      !('serviceWorker' in navigator) || !('PushManager' in window)
        ? 'denied'
        : Notification.permission,
    );
  }, []);

  useEffect(() => {
    // Removido: lógica de salvar preferências do usuário
    reloadChats(query);
  }, [query]);

  const autoSelectDoneRef = useRef(false);

  useEffect(() => {
    if (!ccid || autoSelectDoneRef.current) return;
    if (chatState.selectedChatClientId === ccid) {
      autoSelectDoneRef.current = true;
      return;
    }

    const inList = chatState.chats?.find(
      (c: any) => c.canal_cliente_id?.toString() === ccid,
    );

    if (!inList) return;

    autoSelectDoneRef.current = true;
    selectChat(inList);
  }, [ccid, chatState.chats, chatState.selectedChatClientId, selectChat]);


  const handleBlockContact = (): void => {
    reloadChats(query);
  }

  const [selectedKbSection, setSelectedKbSection] = useState<any>(null);

  const _newLigacaoState = useCallback(() => {
    return {
      status: 'iniciando',
      startDate: null,
      isMuted: false,
      isSpeakerOn: true,
      isMinimized: false,
    } as LigacaoState;
  }, []);

  // // Função para iniciar uma ligação
  // const iniciarLigacao = useCallback(() => {
  //   if (selectedChatIndex > -1 && chatState.chats[selectedChatIndex]) {
  //     setLigacao({
  //       canalId: chatState.chats[selectedChatIndex].canal_id,
  //       canalClienteId: chatState.chats[selectedChatIndex].canal_cliente_id,
  //       canalClienteNome: chatState.chats[selectedChatIndex].cliente?.nome || 'Cliente',
  //       canalClienteImagem: chatState.chats[selectedChatIndex].cliente?.imagem || undefined,
  //     })
  //     setLigacaoState({
  //       status: 'iniciando',
  //       startDate: new Date(),
  //       isMuted: false,
  //       isSpeakerOn: true,
  //       isMinimized: false,
  //     })
  //     // Implementação real para iniciar a ligação
  //     // websocket.emit('call.start', { chatId: chatState.chats[selectedChatIndex].id });
  //   }
  // }, [selectedChatIndex, chatState.chats]);

  // Botão de atalho para testar ligação
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Alt+L para iniciar uma ligação de teste
      if (e.altKey && e.key === 'l' && selectedChat) {
        iniciarLigacao(selectedChat);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedChat]);
  const [isPlayingAudio, setIsPlayingAudio] = useState<boolean>(false);

  const {
    ligacao,
    ligacaoState,
    iniciarLigacao,
    iniciarChamadaOutbound,
    aceitarLigacao,
    conectarLigacao,
    encerrarLigacao,
    transferirLigacao,
    toggleMute,
    toggleSpeaker,
    toggleMinimized
  } = useLigacaoLiveKit(websocket);

  // Estado para o popup de discagem
  const [showPopupDiscagem, setShowPopupDiscagem] = useState(false);

  // Query para verificar se o plano tem ramais e se o usuário atual tem ramal ativo
  const ramalUsuarioQuery = useQuery(
    ['ramal-usuario', user?.id],
    async () => {
      if (!user?.id) return { ativo: false, planoTemRamais: false };
      const [ramalRes, capacidadesRes] = await Promise.all([
        axios.get(`/api/usuario/${user.id}/ramal`, { withCredentials: true }),
        axios.get('/api/capacidades', { withCredentials: true }),
      ]);
      const planoTemRamais = capacidadesRes.data?.ramais !== null && capacidadesRes.data?.ramais !== undefined;
      return { ativo: ramalRes.data?.ativo ?? false, planoTemRamais };
    },
    {
      enabled: !!user?.id,
      staleTime: 30000,
    }
  );

  // Query para buscar canais VoIP com trunk outbound configurado
  const canaisVoipQuery = useQuery(
    ['canais-voip-outbound'],
    async () => {
      const { data } = await axios.get('/api/canal?fi=' + encodeURIComponent(JSON.stringify({ tipo: ['eq', 'voip'] })));
      // Filtrar canais que tem outboundTrunkId configurado
      return data?.result?.filter((canal: any) => {
        try {
          const config = JSON.parse(canal.chave_api || '{}');
          return config.outboundTrunkId || config.outboundServer;
        } catch {
          return false;
        }
      }) || [];
    },
    {
      staleTime: 60000, // Cache por 1 minuto
    }
  );

  const canaisVoip = canaisVoipQuery.data || [];

  // Handler para fazer chamada outbound
  const handleMakeOutboundCall = useCallback((params: {
    clienteId: number;
    clienteNome: string;
    telefone: string;
    canalId: number;
  }) => {
    iniciarChamadaOutbound(params);
    setShowPopupDiscagem(false);
  }, [iniciarChamadaOutbound]);

  const isFiltered = Object.keys(query).some(key => {
    // @ts-ignore
    return query[key] !== undefined && query[key] !== originalQuery[key];
  });

  const [objNewChat, setObjNewChat] = useState<ObjNewChat | null>(null);

  const handleOpenNewChat = () => {
    setObjNewChat({
      canalTipo: null,
      canalValor: null,
      clienteId: null,
      mensagemProgramadaId: null,
      paramsMensagem: null,
    });
  };

  const handleConfirmNewChat = () => {
    if (!objNewChat) return;

    sendNotification(
      null,
      objNewChat!.canalValor!,
      objNewChat!.mensagemProgramadaId!,
      objNewChat!.paramsMensagem || {}
    );

    setObjNewChat(null);
  }

  return (
    <LayoutUsuario>
      {selectedKbSection && (
        <Modal
          size="md"
          title="Base de conhecimento"
          show={!!selectedKbSection}
          onClose={() => setSelectedKbSection(null)}
          onCancel={() => setSelectedKbSection(null)}
          confirmProps={{
            label: (
              <span>
                Ver documentação completa{' '}
                <Icon path={mdiOpenInNew} size={1} />
              </span>
            ),
            href: `/base_conhecimento/${selectedKbSection?.id}/view#secao-${selectedKbSection?.secao_id}`,
            linkTarget: '_blank',
          }}
        >
          <VBox>
            <Titulo>{selectedKbSection?.titulo}</Titulo>

            <p style={{ fontSize: '20px', fontWeight: 'bold' }}>
              {selectedKbSection?.secao_titulo}
            </p>

            <p>{selectedKbSection?.secao_conteudo}</p>

            <AlertBox variant="info">
              Nota: Ver a documentação completa abrirá uma nova aba. Você pode
              fechá-la depois para voltar a este chat.
            </AlertBox>
          </VBox>
        </Modal>
      )}

      <Modal
        title="Finalizar atendimento?"
        show={confirmCloseChat}
        onClose={() => setConfirmCloseChat(false)}
        onConfirm={() => {
          setConfirmCloseChat(false);
          handleChatEstadoChange('finalizado');
        }}
        confirmProps={{
          label: 'Finalizar',
        }}
        cancelProps={{
          label: 'Continuar atendimento',
        }}
      >
        <p>Tem certeza que deseja fechar este chat?</p>
      </Modal>

      <ModalAbrirChatMensagemProgramada
        canalId={selectedChat?.canal_id || selectedChat?.canal?.id}
        open={confirmOpenChat}
        onClose={() => setConfirmOpenChat(false)}
        onConfirm={(mensagemId: string, params: Record<string, string>) => {
          setConfirmOpenChat(false);
          sendNotification(
            selectedChat.id,
            selectedChat.canal_cliente_id?.toString(),
            +mensagemId,
            params
          );
          // handleChatEstadoChange('aguardando_cliente')
        }}
      />

      <ModalSolicitarLigacaoMensagemProgramada
        canalId={selectedChat?.canal_id || selectedChat?.canal?.id}
        open={confirmMakeCall}
        onClose={() => setConfirmMakeCall(false)}
        onConfirm={(mensagemId: string, params: Record<string, string>) => {
          setConfirmMakeCall(false);
          sendNotification(
            selectedChat.id,
            selectedChat.canal_cliente_id?.toString(),
            +mensagemId,
            params
          );
          // handleChatEstadoChange('aguardando_cliente')
        }}
      />

      <ModalNewChat value={objNewChat} onChange={setObjNewChat} onConfirm={handleConfirmNewChat} />

      {/* Popup de Discagem para chamadas outbound */}
      <PopupDiscagem
        show={showPopupDiscagem}
        onClose={() => setShowPopupDiscagem(false)}
        onCall={handleMakeOutboundCall}
        canaisVoip={canaisVoip}
      />

      {/* Componente de Ligação */}
      {Boolean(ligacao) && (
        <Ligacao
          ligacao={ligacao}
          ligacaoState={ligacaoState}
          clienteNome={ligacao!.canalClienteNome}
          clienteImagem={ligacao!.canalClienteImagem}
          // onAtender={aceitarLigacao}
          onAtender={() => { }}
          onEncerrar={(solucionado?: boolean) => encerrarLigacao(solucionado)}
          onTransferir={transferirLigacao}
          onMinimizar={toggleMinimized}
          isMinimizado={ligacaoState?.isMinimized || false}
          tempoInicio={ligacaoState?.startDate || undefined}
          isMuted={ligacaoState?.isMuted || false}
          isSpeakerOn={ligacaoState?.isSpeakerOn || false}
          onToggleMute={toggleMute}
          onToggleSpeaker={toggleSpeaker}
        />
      )}

      <div className={styles.container}>
        <div
          className={[
            styles.conversasContainer,
            selectedChat ? styles.open : null,
          ].join(' ')}
        >
          <div className={styles.conversasHeader} data-testid="container-chats-cabecalho">
            <TituloChat
              wsState={wsState}
              loading={chatState.loadingChats}
              onNewChat={handleOpenNewChat}
              onReloadChats={reloadChats}
              notificationStatus={notificationStatus}
              onAskPermission={askPermission}
              query={query}
              setQuery={(v) => {
                setQuery(v);
                setMessageWhileFiltered(false);
              }}
              resetQuery={() => {
                setQuery(originalQuery);
                setMessageWhileFiltered(false);
              }}
              isFiltered={isFiltered}
              hasNewMessages={isFiltered && messageWhileFiltered}
              canHandleCalls={localCanHandleCalls()}
              callsWarning={getWarningMessage()}
              onOpenDialer={() => setShowPopupDiscagem(true)}
              hasVoipOutbound={canaisVoip.length > 0 && !!ramalUsuarioQuery.data?.planoTemRamais && !!ramalUsuarioQuery.data?.ativo}
            />
          </div>
          <Conversas
            value={chatState.chats}
            selectedKey={selectedChatKey}
            onSelectChat={handleSelectChat}
            loadingChats={chatState.loadingChats}
            hasMoreChats={chatState.hasMoreChats}
            connectionState={wsState}
            onLoadMoreChats={loadMoreChats}
            alertasAtendimento={chatState.fila}
            alertasChamadas={chatState.filaCall}
            onAtender={chatId => atenderFila(chatId)}
            onAtenderChamada={(chamadaId: number) => {
              atenderChamada(chamadaId);
            }}
            isPlayingAudio={isPlayingAudio}
          />
        </div>
        <div
          className={[
            styles.mensagensContainer,
            selectedChat ? styles.open : null,
          ].join(' ')}
          data-testid="container-mensagens"
        >
          {selectedChat && chatState.selectedChatMessages && (
            <Mensagens
              chat={selectedChat}
              value={chatState.selectedChatMessages}
              onChatEstadoChange={onChatEstadoChange}
              onSend={handleSend}
              onReloadChats={reloadChats}
              onChatAddTag={chatAddTag}
              isSending={chatState.sendingMessage}
              onSendAudio={handleSendAudio}
              isLoading={chatState.loadingMessages}
              hasMorePages={chatState.hasMorePages}
              onLoadMore={loadMoreMessages}
              onSelectedKbSection={setSelectedKbSection}
              onGoBack={() => {
                console.log('GOING BACK');
                handleSelectChat(null);
              }}
              canAccept={chatState.fila.filter((it: any) => it.id === selectedChat.id).length > 0}
              onAccept={() => {
                atenderFila(selectedChat.id);
              }}
              onBlockContact={handleBlockContact}
              params={chatState.params}
              onAudioPlaying={setIsPlayingAudio}
              onTyping={sendTypingStatus}
              canMakeCall={true}
              onMakeCall={() => {
                setConfirmMakeCall(true);
              }}
            />
          )}
          {chatState.loadingMessages && !chatState.selectedChatClientId && (
            <div className={`${styles.mensagensPlaceholder} ${styles.fadeIn}`} data-testid="container-mensagens-chat-carregando">
              <VBox>
                <div style={{ textAlign: 'center' }}>
                  <Icon
                    path={mdiMessageProcessing}
                    size={8}
                    color="var(--tc-color-gray-300)"
                    className={styles.blink}
                  />
                </div>
                <span>Carregando mensagens. Aguarde...</span>
              </VBox>
            </div>
          )}
          {!selectedChat && (
            <div className={`${styles.mensagensPlaceholder} ${styles.fadeIn}`} data-testid="container-mensagens-chat-nao-selecionado">
              <VBox>
                <div style={{ textAlign: 'center' }}>
                  <Icon
                    path={mdiMessageProcessing}
                    size={8}
                    color="var(--tc-color-gray-300)"
                  />
                </div>
                <span>Selecione uma conversa para visualizar as mensagens</span>

                <Tutorial id={TutoriaisKeys.CHAT} />
              </VBox>
            </div>
          )}
        </div>
      </div>
    </LayoutUsuario>
  );
};

export default Page;
